/**
 * Breadcrumb Context Enhancer
 * Améliore les breadcrumbs en affichant la collection depuis laquelle l'utilisateur est arrivé
 * Progressive enhancement : fonctionne sans JS grâce au fallback Liquid
 */

(function() {
  'use strict';

  // Vérifier qu'on est sur une page produit
  const breadcrumbElement = document.querySelector('[data-breadcrumb-collection]');
  if (!breadcrumbElement) return;

  // Récupérer les données du produit
  const productCollectionsData = breadcrumbElement.dataset.productCollections;
  const excludedCollectionsStr = breadcrumbElement.dataset.excludedCollections;

  if (!productCollectionsData) return;

  let productCollections;
  try {
    productCollections = JSON.parse(productCollectionsData);
  } catch (e) {
    console.error('Breadcrumb: Erreur parsing JSON', e);
    return;
  }

  const excludedCollections = excludedCollectionsStr ? excludedCollectionsStr.split(',') : [];

  // Lire le referrer
  const referrer = document.referrer;

  // Si pas de referrer ou pas depuis une collection, ne rien faire
  if (!referrer || !referrer.includes('/collections/')) {
    return;
  }

  // Extraire le handle de la collection du referrer
  const match = referrer.match(/\/collections\/([^\/\?#]+)/);
  if (!match || !match[1]) return;

  const referrerCollectionHandle = match[1];

  // Vérifier si la collection est exclue
  if (excludedCollections.includes(referrerCollectionHandle)) {
    console.log('Breadcrumb: Collection exclue:', referrerCollectionHandle);
    return;
  }

  // Vérifier que le produit appartient bien à cette collection
  const matchingCollection = productCollections.find(col => col.handle === referrerCollectionHandle);

  if (!matchingCollection) {
    console.log('Breadcrumb: Produit non dans cette collection:', referrerCollectionHandle);
    return;
  }

  // Vérifier si c'est différent de la collection affichée actuellement
  const currentCollectionUrl = breadcrumbElement.querySelector('[data-collection-url]')?.dataset.collectionUrl;

  if (currentCollectionUrl === matchingCollection.url) {
    // Déjà la bonne collection, ne rien faire
    return;
  }

  // Mettre à jour les breadcrumbs (desktop et mobile)
  updateBreadcrumb('breadcrumb-collection-desktop', matchingCollection);
  updateBreadcrumb('breadcrumb-collection-mobile', matchingCollection);

  console.log('Breadcrumb: Mis à jour avec collection:', matchingCollection.title);

  /**
   * Met à jour un élément breadcrumb avec les nouvelles infos de collection
   */
  function updateBreadcrumb(elementId, collection) {
    const element = document.getElementById(elementId);
    if (!element) return;

    const link = element.querySelector('[data-collection-url]');
    const titleSpan = element.querySelector('[data-collection-title]');

    if (link && titleSpan) {
      // Mettre à jour l'URL
      link.href = collection.url;
      link.dataset.collectionUrl = collection.url;

      // Mettre à jour le titre
      titleSpan.textContent = collection.title;

      // Mettre à jour l'attribut itemprop pour schema.org (si présent)
      const itemProp = link.getAttribute('itemprop');
      if (itemProp === 'item') {
        link.setAttribute('itemprop', 'item');
      }
    }
  }
})();
